import { API_endpoints } from "../config";

export const getProfileInfo = async (id?: number | null): Promise<any> => {
    try {
        const body = id ? { id } : {};

        const response = await fetch(API_endpoints.getProfileInfo, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(body),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Fehler beim Laden von Daten.");
        }

        return await response.json();
        
    } catch (error) {
        console.error("Fehler beim Laden von Daten:", error);
    }
};